import React,{ useEffect, useState, forwardRef, useImperativeHandle, Ref } from 'react';
import BadgesComponent from '@components/common/Badges';
import FormFields from "../../Forms/CommonFormFields";
import './overview.css';
import { useSelector } from 'react-redux';
import {  useUpperComponent } from '../HealthBlockManagementOverview';
import { setZoneId } from '@store/actions/zoneDetailsActions';
import endpoints from '@config/endpoints';
import axios from '../../../utils/axiosExt';
import { zoneDetailsForUpdate } from '@constants/index';
import { useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import Auth from '../../../utils/auth';
import { toast } from 'react-toastify';
import { errorLogger } from '@utils/applicationLogUtils';

interface objectType {
    zoneDivCIr: any;
    flow: string;
    handleChange: (e: any, key: string) => void;
    setUpperComponentState?:(args:any)=>void
}

interface objectTypes {
    isError: boolean,
    message: string,
    isDisable: boolean,
    value: any,
    id?: any,
    verifiedDetails?: any
    code?: any
  }
interface formStateType {
    [key: string]: objectTypes
  }

export interface ChildComponentHandlerUpdateZoneDivCir {
    handleUpdateSave: () => void;
  }

const ZoneDivCirUpdate = forwardRef((props: objectType, ref: Ref<ChildComponentHandlerUpdateZoneDivCir>) => {
    const { zoneDivCIr, flow, handleChange } = props;
    const { zone_name, type } = zoneDivCIr;
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { id } = useParams();
    const [isLoader,setIsLoader]=useState<boolean>(true)
    const districtByZoneData: any = useSelector((state: any) => state?.GeoNonGeoData?.districtByZone);
    const zoneByZoneId: any = useSelector((state: any) => state?.GeoNonGeoData?.zoneByZoneId);
    const [
      updateZoneDivCirFormState, setUpdateZoneDivCirFormState] = useState<formStateType>({
        type: {
            isError: false,
            message: '',
            isDisable:true,
            value: '',
            id:'',
            code:undefined
          },
          effectiveFromDate: {
            isError: false,
            message: '',
            isDisable: true,
            value: '',
          },
          zoneName: {
            isError: false,
            message: '',
            id: '',
            code: undefined,
            isDisable: false,
            value: '',
          },
    });
    const [updateLocationFormState, setUpdateLocationFormState] = useState<formStateType>({

        state: {
            isError: false,
            message: '',
            isDisable: false,
            value: '',
            id:'',
            code:undefined,
          },
        district: {
            isError: false,
            message: '',
            isDisable: false,
            value: [],
            id:[],
            code:[],
          }
    });
   
    const [Component, state] = useUpperComponent();
    // const [zoneDivCirFormState, setZoneDivCirFormState] = useState<any>({
    //     zoneDivCirDetails: {
    //         original:{
    //           type:'',
    //           zoneName:'',
    //           effectiveFromDate:'',
    //         },
    //         updated:{
    //             type:'',
    //             zoneName:'',
    //             effectiveFromDate:'',
    //         },
    //       }
    // })
    const [zoneDetailsForUpdateData,setZoneDetailsForUpdate]=useState(zoneDetailsForUpdate)
  
    useImperativeHandle(ref, () => ({

        handleUpdateSave() {
         // navigate('/zoneDivCIr-management');
            onHandleSave();
    
          }
        }));
        const [zoneCircleId,setZoneCircleId]=useState<string>("")
        const [zoneDeatails,setZoneDetails]=useState<any>()
        const [zoneCode,setZoneCode]=useState<number>()
        useEffect(() => {
            if (state === "upgrade") {
              const dateFormat=new Date(zoneDeatails?.effective_from_dt);
              dateFormat.setDate(dateFormat.getDate()+1);
              const newDate=dateFormat.toISOString().split('T')[0]
                setZoneDetailsForUpdate((zoneDetailsForUpdate: any) => ({
                    ...zoneDetailsForUpdate,
                    effectiveFromDate: {
                      ...zoneDetailsForUpdate.effectiveFromDate,
                      '#isDisabled': false,
                      '#type': 'date',
                      '#title': 'Effective From Date',
            '#webform_key': 'effectiveFromDate',
            '#required': true,
                      '#minDate':dayjs(newDate)
                    }
                  }))
                  setUpdateZoneDivCirFormState((updateZoneDivCirFormState: any) => ({
                    ...updateZoneDivCirFormState,
                    effectiveFromDate: {
                      ...updateZoneDivCirFormState.effectiveFromDate,
                       value: dayjs(zoneDeatails?.effective_from_dt)
                      //value: zoneByZoneId[zoneDivCIr.id][0]?.effective_from_dt
                    }
                  }));
            }
            
            else {
                setZoneDetailsForUpdate((zoneDetailsForUpdate: any) => ({
                    ...zoneDetailsForUpdate,
                    effectiveFromDate: {
                      ...zoneDetailsForUpdate.effectiveFromDate,
                      '#isDisabled': true,
                      '#title': 'Effective From Date',
                      '#type': 'textfield',
            '#webform_key': 'effectiveFromDate',
            '#required': false,
        
                    }
                  }))

                  setUpdateZoneDivCirFormState((updateZoneDivCirFormState: any) => ({
                    ...updateZoneDivCirFormState,
                    effectiveFromDate: {
                      ...updateZoneDivCirFormState.effectiveFromDate,
                      value: dayjs(zoneDeatails?.effective_from_dt).format('DD-MM-YYYY')
                    }
                  }));

            }
        }, [state]);
    if(props?.setUpperComponentState){
        props?.setUpperComponentState(state);
    }
    let typeDetails="Zone Details";
    let typeName="Zone Name";
    if(zoneDivCIr.type?.toLowerCase()==="circle"){
      typeDetails="Circle Details";
      typeName="Circle Name";
  }
  else if(zoneDivCIr.type.toLowerCase()==="division"){
      typeDetails="Division Details";
      typeName="Division Name";
  }
  else{
      typeDetails="Zone Details";
      typeName="Zone Name";

  }
    useEffect(()=>{
      dispatch(setZoneId(zoneDivCIr.id));
    },[zoneDivCIr.id])
    
    useEffect(  ()=>{
      const fetchData = async () => {
        
        try{
          const zoneDetail = await axios.get(`${endpoints.getZoneDivCircleByZDCId(id)}`, Auth.loggedIn());
          const zoneDetails = zoneDetail?.data?.data[0];
          setZoneDetails(zoneDetails)
          setZoneCircleId(zoneDetails.zdc_id);
          setZoneCode(zoneDetails.zdc_code);
          setUpdateZoneDivCirFormState((updateZoneDivCirFormState: any) => ({
            ...updateZoneDivCirFormState,
            type: {
              ...updateZoneDivCirFormState.type,
              value: zoneDetails.type_name,
              id:zoneDetails.type_id
            },
            zoneName: {
              ...updateZoneDivCirFormState.zoneName,
              value: zoneDetails.zdc_name,
              id:zoneDetails.zdc_id,
              code:zoneDetails.zdc_code
            },
            effectiveFromDate: {
              ...updateZoneDivCirFormState.effectiveFromDate,
              value: dayjs(zoneDetails?.effective_from_dt).format('DD-MM-YYYY')
             // value: dayjs(zoneDetails.effective_from_dt).format('DD-MM-YYYY')
            }
          }));
          setUpdateLocationFormState((updateLocationFormState: any) => ({
            ...updateLocationFormState,
            state: {
              ...updateZoneDivCirFormState.state,
              value: `${zoneDetails.state_name}-${zoneDetails.st_code}`,
              id:zoneDetails.st_id,
              code:zoneDetails.st_code
            },
           
           
          }));
       
        
          try{
            const district = await axios.get(`${endpoints.getDistrictsByZDCId(id)}`, Auth.loggedIn());
          const districts = district?.data?.data;
          const distValue = districts?.map((value: any) => `${value.district_name}-${value.district_code}`);
          const distCode = districts?.map((value: any) => value.district_code);
          const distId = districts?.map((value: any) => value.district_id);
          setUpdateLocationFormState((updateLocationFormState: any) => ({
            ...updateLocationFormState,
            district: {
              ...updateZoneDivCirFormState.district,
              value: distValue,
              id: distId,
              code: distCode
            },
          }));
          getDistricts(zoneDetails.st_id,districts);
          }
        catch(error:any){
          errorLogger(error?.response?.data||error?.response||error)
        }
          getStates();
         
          setZoneDetailsForUpdate((zoneDetailsForUpdate: any) => ({
            ...zoneDetailsForUpdate,
            zone_name: {
              ...zoneDetailsForUpdate.zone_name,
             
              '#title': typeName,
              

            }
          }))
        }
        catch(error:any){
            errorLogger(error?.response?.data||error?.response||error)
        }
         
        //   setZoneDivCirFormState({
        //     ...zoneDivCirFormState,
        //     zoneDivCirDetails:{
        //       ...zoneDivCirFormState.zoneDivCirDetails,
        //       original:{
        //         ...zoneDivCirFormState.zoneDivCirDetails.original,
        //         type: zoneDivCIr.type,
        //         zoneName: zoneDivCIr.zoneName,
        //         effectiveFromDate:  zoneByZoneId[zoneDivCIr.id][0]?.effective_from_dt
        //         },
        //         updated:{
        //           ...zoneDivCirFormState.zoneDivCirDetails.updated,
        //           type: zoneDivCIr.type,
        //         zoneName: zoneDivCIr.zoneName,
        //         effectiveFromDate:  zoneByZoneId[zoneDivCIr.id][0]?.effective_from_dt
        //           },
        //       },
        //     }
        //   );
        setIsLoader(false)

      }
      fetchData();
      setIsLoader(false)
    },[]);
    const getStates=async ()=>{
      const states = await axios.getWithCache(`${endpoints.getStates}`, Auth.loggedIn());
      const stateOptions = states.data.data.map((key: any) => ({
        value: `${key.state_name}-${key.state_code}`,
        label: `${key.state_name}-${key.state_code}`,
        id: key.state_id,
        code:key.state_code
      }));
      
      setLocationDetailsForUpdate((locationDetailsForUpdate: any) => ({
        ...locationDetailsForUpdate,
        'state': {
          '#type': 'select',
          '#title': 'State',
          '#isDisabled':true,
          '#options': stateOptions,
          '#webform_key': 'state',
          '#required': false,
        },
     

  }))
    }
    const getDistricts=async (stateId:any,districtAdditional:any)=>{
      const districts = await axios.get(`${endpoints.getDistrictsforZoneByStateId(stateId)}`, Auth.loggedIn());
      const distOptions = districts.data.data.map((key: any) => ({
        value: `${key.district_name}-${key.district_code}`,
        label: `${key.district_name}-${key.district_code}`,
        id: key.district_id,
        code: key.district_code
      }));
      const additionalDist=districtAdditional.map((key: any) => ({
        value: `${key.district_name}-${key.district_code}`,
        label: `${key.district_name}-${key.district_code}`,
        id: key.district_id,
        code: key.district_code
      }));

      const mergedDistOptions = [ ...additionalDist,...distOptions];
 

      setLocationDetailsForUpdate((locationDetailsForUpdate: any) => ({
        ...locationDetailsForUpdate,
        district: {
          ...locationDetailsForUpdate.district,
          '#options': mergedDistOptions,
        },
     

  }))
    }
   
    // useEffect(()=>{
    //   const existingOptions:any ={...locationDetailsForUpdateData};
    //   existingOptions['district']['#options']=districtByZoneData[zoneDivCIr.id];
    //   if(existingOptions['district']['#options']?.length!==0){
    //   setLocationDetailsForUpdate(existingOptions);
    //   }
    //   else{
    //     setLocationDetailsForUpdate({
    //       'state': {
    //         '#type': 'select',
    //         '#title': 'State',
    //         '#isDisabled':true,
    //         '#options': districtOptions,
    //         '#webform_key': 'state',
    //         '#required': false,
    //       },
    //       'district': {
    //         '#type': 'select',
    //         '#title': 'District',
    //         '#isDisabled':true,
    //         '#options': [],
    //         '#webform_key': 'district',
    //         '#required': false,
    //       }

    // })
      
    //   }
    // },[districtByZoneData[zoneDivCIr.id]])

    const transformDataArray = (dataArray: any) => {
        return dataArray?.length && dataArray?.map((item: any) => {
            const transformedItem: any = {};
            for (const key in item) {
                if (key.startsWith("district_")) {
                    const newKey = key.replace("district_", "");
                    let finalKey = newKey; let value = item[key];
                    if (newKey === "name") {
                        finalKey = "label";
                        value = `${item[key]}-${item['district_code']}`
                    } else if (newKey === "code") {
                        finalKey = "value";
                        value = item[key];
                    }
                    transformedItem[finalKey] = value;
                }

            }
            return transformedItem;
        });
    };

    const districtOptions = districtByZoneData[zoneDivCIr.id];
    const district = districtByZoneData[zoneDivCIr.id]?.map((district:any)=>district.district_name).join(' , ');
    const [locationDetailsForUpdateData,setLocationDetailsForUpdate]=useState({
        'state': {
            '#type': 'select',
            '#title': 'State',
            '#isDisabled':true,
            '#options': {},
            '#webform_key': 'state',
            '#required': false,
          },
        'district': {
            '#type': 'select',
            '#title': 'District',
            '#isDisabled':false,
            '#options': {},
            '#webform_key': 'district',
            '#multiDropdown':true,
            '#required': true,
          }
    })
    const handleZoneDivCirForm = (value: any | boolean, key: string, option?: any, id?: any, code?: any) => {
    
        setUpdateZoneDivCirFormState((prevState: any) => ({
          ...prevState,
          [key]: {
            ...prevState[key],
            value: value,
            isError: false,
            message: '',
            id: id,
            code: code
          },
        }));

        // setZoneDivCirFormState({
        //     ...zoneDivCirFormState,
        //     zoneDivCirDetails:{
        //       ...zoneDivCirFormState.zoneDivCirDetails,
        //       updated:{
        //       ...zoneDivCirFormState.zoneDivCirDetails.updated,
        //         [key]:value
        //       }
        //     }
        //   });
      }
      
const handleLocationForm=(value: any | boolean, key: string,option?:any,id?:any,code?:any)=>{
    setUpdateLocationFormState((prevState: any) => ({
        ...prevState,
        [key]: {
          ...prevState[key],
          value: value,
          isError: false,
          message: '',
          id: id,
          code: code
        },
      }));
}

      const isError: boolean[] = [];
      let isSimilarName=false;
      
    const onHandleSave = async () => {

        {const zoneCirDivFormError = {
            ...updateZoneDivCirFormState
          };
          const updateLocationFormError = {
            ...updateLocationFormState
          };
          let isZoneDivCirFormError = false;
          
          if(updateZoneDivCirFormState.zoneName.value!=='' && zoneDivCIr.zone_name!==updateZoneDivCirFormState.zoneName.value){
            try{
                const response = await axios.get(`${endpoints.checkZoneDivCicleExist(zoneDeatails?.st_id,updateZoneDivCirFormState.zoneName.value)}`, Auth.loggedIn());
                const data1=response.data?.data[0];
                isSimilarName=data1?.check_zone_div_circle_exists;
                
              }
          catch(error:any){
            errorLogger(error?.response?.data||error?.response||error)
          }
          }

          Object.keys(zoneCirDivFormError).map( (item) => {
            if (item === 'zoneName') {
                
                if (!zoneCirDivFormError.zoneName.value) {
                  zoneCirDivFormError.zoneName.isError = true;
                  isZoneDivCirFormError = true;
                  if(zoneCirDivFormError.type.value.toLowerCase()==='division'){
                    zoneCirDivFormError.zoneName.message =  'Division name is mandatory.';
                  }
                  else if(zoneCirDivFormError.type.value.toLowerCase()==='zone'){
                    zoneCirDivFormError.zoneName.message =  'Zone name is mandatory.';
                  }
                  else if(zoneCirDivFormError.type.value.toLowerCase()==='circle'){
                    zoneCirDivFormError.zoneName.message =  'Circle name is mandatory.';
                  } 
                  else{
                  zoneCirDivFormError.zoneName.message =  'The name is mandatory.';

                  }
                }
                else if(isSimilarName){
                    zoneCirDivFormError.zoneName.isError = true;
                    isZoneDivCirFormError = true;
                    zoneCirDivFormError.zoneName.message = 'The name already exists. Choose a unique name to continue.';  
                }
                else {

                    zoneCirDivFormError.zoneName.isError = false;
                }
              }
            else if (item === 'effectiveFromDate') {
                
                if (!zoneCirDivFormError.effectiveFromDate.value) {
                  zoneCirDivFormError.effectiveFromDate.isError = true;
                  isZoneDivCirFormError = true;
                  zoneCirDivFormError.effectiveFromDate.message =  'Select effective from date to create new version.';
                }
              
                else {

                    zoneCirDivFormError.effectiveFromDate.isError = false;
                }
              }
          })
          Object.keys(updateLocationFormError).map( (item) => {
            if (item === 'district') {
                
                if (updateLocationFormError.district.value.length===0) {
                  updateLocationFormError.district.isError = true;
                  isZoneDivCirFormError = true;
                  updateLocationFormError.district.message =  'Select district from the dropdown';
                }
                
                else {

                  updateLocationFormError.district.isError = false;
                }
              }
          })
          setUpdateZoneDivCirFormState(zoneCirDivFormError);
          setUpdateLocationFormState(updateLocationFormError);
      isError[0] = isZoneDivCirFormError;
    }
    //  const districtIds: any[]=[];
    //  const districtCodes:any[]=[];
    //  locationDetailsForUpdateData.district['#options'].map((item:any)=>districtIds.push(item.district_id));
    //  locationDetailsForUpdateData.district['#options'].map((item:any)=>districtCodes.push(item.district_code));
    
       if(!isError[0]){
        let  date=dayjs(updateZoneDivCirFormState.effectiveFromDate.value).format('YYYY-MM-DD'); 

        if(state==="correction"){
           dayjs.extend(customParseFormat);
           date=dayjs(updateZoneDivCirFormState.effectiveFromDate.value, "DD-MM-YYYY").format('YYYY-MM-DD'); 

        }
      
        
       // const beforeDt=new Date(updateZoneDivCirFormState.effectiveFromDate.value);
        // const date=dayjs(updateZoneDivCirFormState.effectiveFromDate.value); 
        // //const date=dayjs(updateZoneDivCirFormState.effectiveFromDate.value); 
        // const formatedDate=date.format('YYYY-MM-DD');
            const payload: any = {
              "zoneDivCircleId": zoneCircleId,
              "zoneDivCircleCode": zoneCode,
              "stCode": updateLocationFormState.state.code,
              "stateId": updateLocationFormState.state.id,
              "zoneDivCircleName": updateZoneDivCirFormState.zoneName.value,
              "typeId": zoneDivCIr?.type_id,
              "effectiveFromDt":date,
              "districtIds": updateLocationFormState.district.id,
              "districtCodes": updateLocationFormState.district.code,
              "parentUserId": '',
              "parentUserTypeId": ''
            }

            let endpoint = endpoints.updateZoneDivCir;
            if (state === 'upgrade') {
              endpoint = endpoints.upgradeZoneDivCir;
            }
            const response: any = await axios.put(`${endpoint}`, payload, Auth.loggedInWithJSON());
       
            if (response.status === 200) {
              navigate(`/zone`);
              if (state === 'upgrade') {
              toast.success("Records have been successfully upgraded & saved", {
                position: "top-center"
              });
            }
            else{
              toast.success("Records have been successfully updated & saved", {
                position: "top-center"
              });
            }
            }
        }
          
    }


    return (
        <>{isLoader?<div className='loader'>Loading...</div>:<div>
        <div className="overview_zoneDivCir_update">
            <div className="zoneDivCir_update">
                {!(flow==="view") &&Component}
                <BadgesComponent
                    className="over-badge"
                    badgeName={typeDetails}
                    variant="primary-1"
                    badgeType="case5"
                />  
                <div className="overview-details-update">
                <div className="update_zoneDivCir_details_page">
                  <form className="update_container_zoneDivCir_details">
                    <FormFields
                      formData={zoneDetailsForUpdateData}
                      formState={updateZoneDivCirFormState}
                      handleFormChange={handleZoneDivCirForm}
                    />
                  </form>
                </div>
                <hr></hr>
              </div>
            </div>
            </div>
            
            <div className="overview_zoneDivCir_update">
            <div className="location_update">
                <BadgesComponent
                    className="over-badge"
                    badgeName="Location details"
                    variant="primary-1"
                    badgeType="case5"
                />
                 <div className="overview-details-update">
                <div className="update_location_details_page">
                  <form className="update_container_location_details">
                    <FormFields
                      formData={locationDetailsForUpdateData}
                      formState={updateLocationFormState}
                      handleFormChange={
                      (value: any, key: string, id: any, option: any, code: any) => {
                      if (key === 'district') {
                          const uniqueValues: string[] = Array.from(new Set<string>(value || []));

                          const idMap = new Map<string, any>();
                          const codeMap = new Map<string, any>();
                          option?.forEach((op: any) => {
                          if (uniqueValues.includes(op.value)) {
                          idMap.set(op.value, op.id);
                          codeMap.set(op.value, op.code);
                      }
                });

                          value = uniqueValues;
                          id = uniqueValues.map((v: string) => idMap.get(v));
                          code = uniqueValues.map((v: string) => codeMap.get(v));
                }
                          handleLocationForm(value, key, option, id, code)
              }
           }
                    />
                  </form>
                </div>
                <hr></hr>
              </div>
            </div>
            </div>
            </div>}
        </>
    );
});
ZoneDivCirUpdate.displayName = 'ZoneDivCirUpdate';
export default ZoneDivCirUpdate;
